import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { PdfViwer } from "../components/PdfViwer";
import { INewsEventsData } from "../exports/interfaces";
import { stripHtml } from "../exports/functions";
import calendarIcon from "../assets/img/icons/calendar.svg";
import { Link, useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/custom/useToast";
import { fetchNews } from "../api/NewsEventsApi";

const NewsPage = () => {
  const { setLoading } = useLoader();

  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname, location.hash]);

  const [news, setNews] = useState<INewsEventsData[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchNews()])
      .then(([newsData]) => {
        setNews(newsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  const PostLayout = (props: { post: INewsEventsData }) => {
    const [openPdf, setOpenPdf] = useState(false);
    const [pdfPath, setPdfPath] = useState("");

    const openViewer = (path: string) => {
      setPdfPath(path);
      setOpenPdf(true);
    };

    const closeViewer = () => setOpenPdf(false);

    const fileSource = props.post.pdf_file?.length
      ? props.post.pdf_file
      : props.post.file;
    const pdfUrl = fileSource?.[0]?.media?.url;
    const contentImage =
      props.post.image?.[0]?.media?.url ||
      props.post.thumbnail?.[0]?.media?.url;
    const hasDetailContent = !pdfUrl && (props.post.text || contentImage);
    const redirectUrl = stripHtml(props.post.link);

    return (
      <>
        <div
          className="col-lg-4 wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <div className="td_post td_style_1">
            {/* <a
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="td_post_thumb d-block"
                >
                  <img src={post.src} alt="blog post" />
                  <i className="fa-solid fa-link"></i>
                </a> */}

            <div className="td_post_info" style={{ height: "305px" }}>
              <div className="td_post_meta td_fs_14 td_medium td_mb_20">
                <span>
                  <img src={calendarIcon} alt="calendar icon" />
                  {props.post.date}
                </span>
              </div>

              <h2 className="td_post_title td_fs_24 td_medium td_mb_16">
                {pdfUrl ? (
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      openViewer(fileSource?.[0]?.media?.url || "");
                    }}
                  >
                    {props.post.title}
                  </Link>
                ) : hasDetailContent ? (
                  <Link to="/news-detail" state={{ post: props.post }}>
                    {props.post.title}
                  </Link>
                ) : (
                  <Link
                    to={redirectUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {props.post.title}
                  </Link>
                )}
              </h2>

              <p className="td_post_subtitle td_mb_24 td_heading_color td_opacity_7">
                {props.post.sub_title}
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {pdfUrl ? (
                  <Link
                    to="#"
                    className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                    onClick={(e) => {
                      e.preventDefault();
                      openViewer(fileSource?.[0]?.media?.url || "");
                    }}
                  >
                    <span className="td_btn_in td_accent_color">
                      <span>Read More</span>
                    </span>
                  </Link>
                ) : hasDetailContent ? (
                  <Link
                    to="/news-detail"
                    state={{ post: props.post }}
                    className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                  >
                    <span className="td_btn_in td_accent_color">
                      <span>Read More</span>
                    </span>
                  </Link>
                ) : (
                  <Link
                    to={redirectUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                  >
                    <span className="td_btn_in td_accent_color">
                      <span>Read More</span>
                    </span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
      </>
    );
  };

  return (
    <>
      <Banner title="News" />

      <section id="news-events">
        <div className="td_height_112 td_height_lg_40" />
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            {/* <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            HIGHLIGHTS
          </p> */}
            <h2 className="td_section_title td_fs_48 mb-0">News</h2>
          </div>

          <div className="td_height_30 td_height_lg_30" />
          {news?.length > 0 ? (
            <div className="td_notice_tabs">
              <div className="row td_gap_y_30 justify-content-center">
                {news.map((post) => (
                  <PostLayout post={post} />
                ))}
              </div>
            </div>
          ) : (
            <p style={{ display: "flex", justifyContent: "center" }}>
              No news available. Please check again later.
            </p>
          )}
        </div>

        <div className="td_height_120 td_height_lg_40" />
      </section>
    </>
  );
};

export default NewsPage;
